/* eslint-disable */

/* ---------------------------------------------------
Import modules
----------------------------------------------------- */

import SimpleSelector from 'simple-selector';
import IndexedSearchFormController from './controller';
import AccordionController from 'accordions';
import HighlightController from 'scripts/marmalade/classes/highlighter';
import ScrollToTopController from 'scripts/marmalade/classes/scroll-to-top';

/* ---------------------------------------------------
Search Page
----------------------------------------------------- */

// If we dont have a search page do nothing
const page = document.querySelector('.js-search-modal');
// Find the search form
const form = page.querySelector('.js-search-modal__form');
// Find the controls
const controls = page.querySelector('.js-search-modal__controls');
// Find the filters
const filters = page.querySelector('.js-search-modal__filters');
// Find the results list
const list = page.querySelector('.js-search-modal__list');
// find the results
const results = page.querySelector('.js-search-modal__results');
// Find the keyword input
const keyword = page.querySelector('.js-search-modal__keyword');
// Find the popular topics
const popularTopics = page.querySelector('.js-search-modal__topics');
// Find all the topic radio buttons
const topicRadios = [...popularTopics.querySelectorAll('input')];
// Find the load more button
const loadMore = page.querySelector('.js-search-modal__load-more');
// Find the close buttons
const closeButtons = [...page.querySelectorAll('.js-search-modal__close')];
// The page length
const length = 50;
// A class name for the items
const className = 'search-result';
// The current search parameters
const search = new URLSearchParams(window.location.search);
// Create an array to hold the search results as html
const paginatedResults = [];
// Timeouts
const timeouts = {};

// Create a new AccordionController
const Accordion = new AccordionController(page);

// Create a new IndexedSearchFormController
const IndexedSearch = new IndexedSearchFormController(form, {
  parametersThatUpdateFilters: ['keyword']
});

// Create a new HighlightController
const Highlighter = new HighlightController();

// Create a new ScrollToTopController
const ScrollToTop = new ScrollToTopController(list);

// Set up a mutation observer to watch the value of the keyword
const updateKeywordURL = () => {
  // First grab all the query parameters
  const search = new URLSearchParams(window.location.search);

  // if the keyword is set, add it to the search, otherwise remove it
  keyword.value != '' ? search.set('q', keyword.value) : search.delete('q');
  let urlPath = search.toString() === '' ? window.location.pathname + window.location.hash : window.location.pathname + '?' + search.toString() + window.location.hash;
  window.history.replaceState({}, '', urlPath);
};

// A function to add 20 more results to the page
const appendResults = () => {
  // Add the first 20 results to the page
  results.innerHTML += paginatedResults.slice(0, length).join('');
  // Remove the first results from the array
  paginatedResults.splice(0, length);
  // Hide the load more button if there are no more results
  loadMore.classList.toggle('hidden', paginatedResults.length === 0);
  // Hide the controls if there are no results
  controls.classList.toggle('hidden', results.innerHTML === '');

  // Loop through all the results on the page
  [...results.children].forEach(result => {
    Highlighter.mark(result);
  });
  clearTimeout(timeouts.appendResults);
  timeouts.appendResults = setTimeout(() => {
    list.classList.remove('loading');
  }, 300);
};
IndexedSearch.on('change', () => {
  // Add the loading class
  list.classList.add('loading');
  // Submit the form
  IndexedSearch.submit();
});

// After the form submits, do something with the results
IndexedSearch.on('submit', data => {
  // Remove the loading class
  list.classList.remove('loading');

  // empty the html array
  paginatedResults.length = 0;

  // Clear the results html
  results.innerHTML = '';

  // Loop through the results
  data.forEach(result => {
    // If this result is a video
    if (result.category == 'Videos') {
      paginatedResults.push(`
        <div class="${className}-video [ js-video ]">
          <span class="${className}-video__title">${result.title}</span>

          <div class="${className}-video__media [ js-video__media ]" data-video="${result.link}">
            <div href="#" class="${className}-video__thumbnail" data-src="${result.thumbnail_url}"></div>
            <a id="VideoEmbed_${result.id}" class="${className}-video__link"></a>
          </div>

          <div class="${className}-video__details">
            ${result.summary ? `<span class="${className}-video__caption">${result.summary}</span>` : ''}
          </div>

          ${result.transcript ? `
            <div class="${className}-video__body [ js-video__transcript ]">
              <button class="${className}-video__toggle">Transcript</button>
              <div class="${className}-video__transcript">
                <p>${result.transcript}</p>
              </div>
            </div>
          ` : ''}
        </div>
      `);
    }

    // If this result has a file_size or file_extension, this result is a downloadable file
    else if (result.file_size || result.file_extension) {
      paginatedResults.push(`
        <div class="${className}">
          <a href="${result['link']}" class="${className}__link">
            <div class="${className}__main">
              <div class="${className}__download">
                <span class="${className}__icon" data-ext="${result.file_extension}"></span>
                <span class="${className}__title">${result.title}</span>
                <span class="${className}__size">${result.file_size}</span>
                <span class="${className}__type">${result.file_extension}</span>
                <span class="${className}__icon"></span>
              </div>

              <div class="${className}__data">
                <span class="${className}__date">${result.date}</span>
              </div>
            </div>
          </a>
        </div>
      `);
    }

    // If this result has a link, this result is a page
    else if (result.link) {
      paginatedResults.push(`
        <div class="${className}">
          <a href="${result['link']}" class="${className}__link">
            <div class="${className}__main">
              <span class="${className}__title">${result.title}</span>
              <span class="${className}__url">${result.link}</span>
              <p class="${className}__summary">${result.summary}</p>
              <div class="${className}__data">

                <span class="${className}__date">${result.date}</span>
              </div>
            </div>
          </a>
        </div>
      `);
    }

    // new html template for the item
  });

  // Append results to the page
  appendResults();
});

// Take over the render function
IndexedSearch.onRender((response, results) => {
  // Create a new div
  const filters = document.createElement('div');
  // Create a reset button
  const reset = document.createElement('button');
  // Create a count for the number of results
  const count = document.createElement('span');
  // Create an object of arrays to determine the order of the filters
  const order = {
    Pages: [],
    Documents: [],
    Stories: [],
    News: [],
    Events: [],
    Other: []
  };

  // Set the reset button text
  reset.innerText = 'Clear filters';
  // Set the reset button type
  reset.type = 'reset';

  // Add a class to the count
  count.classList.add('count');
  // Set the count text to the number of results
  count.innerText = results + ' result' + (results === 1 ? '' : 's');

  // Append the count to the fieldset
  filters.appendChild(count);

  // Loop through the data
  response.forEach(function () {
    let filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // Create a new div
    const fieldset = document.createElement('div');
    // Create a legend
    const legend = document.createElement('legend');

    // Set the legend text
    legend.innerText = filter.label;

    // Append the legend to the fieldset
    fieldset.appendChild(legend);

    // Loop all the options
    filter.options.forEach((option, index) => {
      // Create a new div
      const div = document.createElement('div');
      // Create a radio input
      const radio = document.createElement('input');
      // Create a label
      const label = document.createElement('label');

      // Set the radio type
      radio.type = 'radio';
      // Set the radio name
      radio.name = filter.field;
      // Set the radio ID
      radio.id = radio.name + '-' + index;
      // Set the radio value
      radio.value = option.value;

      // Set the label text
      label.innerText = option.value + ' (' + option.count + ')';
      // Set the label for
      label.htmlFor = radio.id;

      // Append the radio to the div
      div.appendChild(radio);
      // Append the label to the div
      div.appendChild(label);

      // Append the div to the fieldset
      fieldset.appendChild(div);

      // Add the div to the order object using the value as the key
      order[option.value] ? order[option.value].push(div) : order.Other.push(div);

      // If this value is in the value object, select the option
      if (IndexedSearch.value['filter'][filter.field] == undefined) return;
      if (!IndexedSearch.value['filter'][filter.field].includes(radio.value)) return;

      // Check the radio
      radio.checked = true;
    });

    // Loop through the order object
    Object.keys(order).forEach(key => {
      // Loop through the filters
      order[key].forEach(filter => {
        // Append the filter to the fieldset
        fieldset.appendChild(filter);
      });
    });

    // Append the reset button to the fieldset
    fieldset.appendChild(reset);

    // Append the fieldset to the filters
    filters.appendChild(fieldset);
  });

  // Return the filters in the callback
  return filters;
});

// After the filters render, put them on the page
IndexedSearch.on('render', element => {
  // Clear the filters
  filters.innerHTML = '';
  // Append the new filters
  filters.appendChild(element);
});
SearchModal.on('open', () => {
  // If there is a keyword
  if (keyword.value) {
    // Inject the keyword into the search
    IndexedSearch.value.parameter['keyword'] = keyword.value;
    // Submit the form
    IndexedSearch.submit();
  }
});
SearchModal.on('close', () => {
  // We need to remove all the videos
  [...page.querySelectorAll('.js-video')].forEach(video => {
    // Find the iframe
    const iframe = video.querySelector('iframe');
    // If there is no iframe, return
    if (!iframe) return;
    // Remove the iframe
    iframe.parentNode.removeChild(iframe);
  });
});

// When we click the load more button, add more results to the page
loadMore.addEventListener('click', appendResults);

// When we type in the keyword input, clear the filters
keyword.addEventListener('input', () => {
  // Clear the filters
  IndexedSearch.clearFilters();

  // Update the Highlighter term
  Highlighter.setTerm(keyword.value);

  // Loop through the topic radios
  topicRadios.forEach(topic => {
    // If the keyword matches the topic value (lowercase), check it, otherwise uncheck it
    topic.checked = keyword.value.toLowerCase() === topic.value.toLowerCase();
  });
});

// Set up all the simple-selectors
[...form.querySelectorAll('select')].forEach(select => {
  select.SimpleSelector = new SimpleSelector(select);
});

// When the user clicks on any of the close buttons
closeButtons.forEach(button => {
  button.addEventListener('click', () => {
    // Close the search modal
    // SearchModal is defined in search.js
    SearchModal.close();
    // Clear the filters
    IndexedSearch.clearFilters();
    // Clear the keyword
    keyword.value = '';
    updateKeywordURL();
    // Empty the results
    results.innerHTML = '';
    // Hide the load more button
    loadMore.classList.add('hidden');
    // Hide the controls
    controls.classList.add('hidden');
  });
});

// Find all the topic radio buttons inside the popularTopics
topicRadios.forEach(topic => {
  // when the user clicks on a topic, update the keyword input
  topic.addEventListener('change', () => {
    if (topic.checked) {
      keyword.value = topic.value;
      updateKeywordURL();
      // Update the Highlighter term
      Highlighter.setTerm(keyword.value);
      IndexedSearch.clearFilters();
    }
    ;
  });
});
if (topicRadios.length) Accordion.add(popularTopics);
ScrollToTop.on('click', () => {
  // Scroll the list to the top smoothly
  SearchModal.scrollToTop();
});

// Update the keyword input value
keyword.value = search.get('q') || '';
updateKeywordURL();
keyword.addEventListener('input', () => {
  updateKeywordURL();
});

// Submit the form
IndexedSearch.submit();